export function fieldHasErrors(field) {
  if (field && !field?.required && !field?.photoRequired) return false

  const v = field?.required && !field?.value
  const i = field?.requireFollowupPhoto && (!field?.images || Object.keys(field?.images || {}).length < 1)
  const c = field?.requireFollowupComments && !field?.comment

  return [v, i, c].some((x) => x)
}
